import { render, staticRenderFns } from "./NewsModify.vue?vue&type=template&id=76c0564e&scoped=true&"
import script from "./NewsModify.vue?vue&type=script&lang=js&"
export * from "./NewsModify.vue?vue&type=script&lang=js&"
import style0 from "./NewsModify.vue?vue&type=style&index=0&id=76c0564e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0564e",
  null
  
)

export default component.exports